<template>
    <div class="session__show_attendance_item">
        <div class="session__show_attendance_item_top">
            <div class="columns is-vcentered">
                <div class="column">
                    <div class="session__show_attendance_item_top_title custom--padding">{{ title }}</div>
                </div>
                <template v-if="newDate">
                    <div class="column is-narrow has-text-right">
                        <div class="session__show_attendance_item_top_date custom--padding">{{ newDate }}</div>
                    </div>
                </template>
            </div>
        </div>
        <div class="session__show_attendance_item_bottom">
            <div class="columns is-vcentered">
                <div class="column">
                    <div class="session__show_attendance_item_bottom_description custom--padding">{{ description }}</div>
                </div>
                <div class="column is-narrow has-text-right">
                    <div class="columns is-vcentered">
                        <div class="column">
                            <div class="session__show_attendance_item_bottom_status custom--padding">
                                <component-status :status="status || itemStatusOutput"/>
                            </div>
                        </div>
                        <div class="column">
                            <div class="session__show_attendance_item_bottom_actions">
                                <component-button
                                    :theme="'default'"
                                    :border="true"
                                    :name="`session-show-attendance-item-bottom-actions-print-${id}`"
                                    @click="handlePrint"
                                >{{ $t('ebs.sessions.show.buttons.print') }}
                                </component-button>
                            </div>
                        </div>
                        <div class="column is-narrow">
                            <div class="session__show_attendance_item_bottom_actions">
                                <component-button
                                    :to="to"
                                    :name="`session-show-attendance-item-bottom-actions-view-${id}`"
                                >{{ $t('ebs.sessions.show.buttons.view') }}
                                </component-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="popnotifyprint"
            :class="[
                'pop__notify--print',
                'session__show_attendance_item_notifyprint'
            ]"
            :title-text="`${description} layout`"
            :content-text="''"
            :cancel-button-text="'Cancel'"
            :submit-button-active="true"
            :submit-button-text="'Print'"
            @emit-submit="redirectToPrint"
        >
            <form-checkbox
                :name="'session-show-attendance-notify-include-email'"
                :label="'Include email address column'"
                v-model="includeEmailInPrint"
            ></form-checkbox>
            <form-checkbox
                :name="'session-show-attendance-notify-include-additional-column'"
                :label="'Include additional column'"
                v-model="includeAdditionalColumnInPrint"
            ></form-checkbox>
            <form-text
                :disabled="!includeAdditionalColumnInPrint"
                :name="'session-show-attendance-notify-additional-column-name'"
                :label="'Additional column name'"
                v-model="additionalColumnName"
            ></form-text>
        </pop-notify>
    </div>
</template>

<script>
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'
import PopNotify from '@/components/default/shared/PopNotify'
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import FormText from '@/components/default/forms/FormText'

export default {
  components: {
    FormText,
    FormCheckbox,
    PopNotify,
    ComponentButton,
    ComponentStatus
  },
  name: 'session-show-attendance-item',
  data () {
    return {
      includeEmailInPrint: false,
      includeAdditionalColumnInPrint: false,
      additionalColumnName: ''
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    id: {
      type: [String, Number],
      default: '',
      required: true
    },
    title: {
      type: [String, Number],
      default: '',
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    to: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    itemAttendanceRegistryFilled () {
      return this.item.attendanceRegistryFilled
    },
    itemAttendanceRegistryCompleted () {
      return this.item.attendanceRegistryCompleted
    },
    itemStatusOutput () {
      let status

      if (this.itemAttendanceRegistryCompleted) {
        status = 'submitted'
      } else if (this.itemAttendanceRegistryFilled && !this.itemAttendanceRegistryCompleted) {
        status = 'not_submitted'
      } else if (!this.itemAttendanceRegistryFilled && !this.itemAttendanceRegistryCompleted) {
        status = 'marking_required'
      }

      return status
    },
    newDate () {
      if (this.date) {
        return new Date(this.date).toLocaleDateString('en-gb', {
          weekday: 'short',
          year: 'numeric',
          month: 'short',
          day: '2-digit'
        })
      }
      return false
    }
  },
  methods: {
    openNotifyPrint () {
      this.includeEmailInPrint = false
      this.includeAdditionalColumnInPrint = false
      this.additionalColumnName = ''

      this.$refs.popnotifyprint.openNotify()
    },
    closeNotifyPrint () {
      this.$refs.popnotifyprint.closeNotify()
    },
    handlePrint () {
      this.openNotifyPrint()
    },
    redirectToPrint () {
      let query = {}

      if (this.includeEmailInPrint) {
        query.includeEmailInPrint = true
      }
      if (this.includeAdditionalColumnInPrint) {
        query.includeAdditionalColumnInPrint = true
      }
      if (this.additionalColumnName) {
        query.additionalColumnName = this.additionalColumnName
      }

      const routeData = this.$router.resolve({
        name: `${this.to.name}-print`,
        params: this.to.params,
        query: query
      })

      this.closeNotifyPrint()
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
